import React, { useContext } from 'react'
import styled from 'styled-components'
import Footer from '../containers/Footer'
import Subscribe from '../containers/Subscribe'
import Header from '../containers/Header'
import ServiceCards from '../containers/ServiceCards'
import ImpactPanels from '../containers/ImpactPanels'
import PersonalisedNav from '../containers/PersonalisedNav'
import HeroBanner from '../containers/HeroBanner'
import CancerTypeSelector from '../containers/CancerTypeSelector'
import { ThemeProvider } from 'styled-components'
import { GridThemeProvider } from 'styled-bootstrap-grid'
import GlobalStyles from '../styles'
import THEME from '../styles/Theme'
import gridTheme from '../styles/GridTheme'
import FontScaling from '../styles/FontScaling'
import SEO from '../components/SEO'
import { graphql } from 'gatsby'
import { rem } from '../styles/Mixins'
import { media } from 'styled-bootstrap-grid'
import { withAlert, AlertContext } from '../components/Alert/AlertContext'

const Body = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  /* adding more padding at the bottom if impact panel is last section */
  section {
    :last-child[class*='ImpactPanels__Section'] {
      ${media.xl`
        margin-bottom: ${rem(180, 'xxxl')};
      `} :after {
        ${media.xl`
          bottom: -65px;
          left: -160px;
        `}

        ${media.xxl`
          bottom: -75px;
          left: -145px;
        `}

        @media (min-width: 1920px) {
          bottom: -115px;
          left: -111px;
        }
      }
    }
  }
`

const Home = (props) => {
  const { height } = useContext(AlertContext)

  return (
    <div id="root" className="static">
      {' '}
      <ThemeProvider theme={THEME}>
        <GridThemeProvider gridTheme={gridTheme}>
          <SEO
            title={
              props?.data?.wpPage?.acfCustomPageHeader?.pageTitle
                ? props?.data?.wpPage?.acfCustomPageHeader?.pageTitle
                : props?.data?.wpPage?.title
            }
            postYoastData={props?.data?.wpPage?.seo}
          />
          <GlobalStyles />
          <FontScaling>
            <Header />
            <Body
              id="main"
              className="home"
              style={height ? { marginTop: height } : {}}
            >
              <HeroBanner tabs={props?.data?.wpPage?.acfHomepage?.bannerTabs} />
              <ServiceCards
                tabs={props?.data?.wpPage?.acfHomepage?.contentTabs}
              />
              {props?.data?.wpPage?.acfHomepage?.showSection && (
                <CancerTypeSelector />
              )}
              <PersonalisedNav
                title={props?.data?.wpPage?.acfHomepage?.sectionTitle}
                cards={props?.data?.wpPage?.acfHomepage?.adviceCards}
              />
              <ImpactPanels
                button_link={
                  props?.data?.wpPage?.acfHomepage?.buttonLink
                    ? props?.data?.wpPage?.acfHomepage?.buttonLink?.uri
                    : null
                }
                button_text={
                  props?.data?.wpPage?.acfHomepage?.buttonText
                    ? props?.data?.wpPage?.acfHomepage?.buttonText
                    : null
                }
                has_link={
                  props?.data?.wpPage?.acfHomepage?.tabLink ? true : false
                }
                heading={props?.data?.wpPage?.acfHomepage?.tabHeading}
                subtitle={props?.data?.wpPage?.acfHomepage?.tabSubtitle}
                tabs={props?.data?.wpPage?.acfHomepage?.impactTabs}
              />
            </Body>
            <Subscribe awsEndpoint={props?.pageContext?.awsEndpoint} />
            <Footer awsEndpoint={props?.pageContext?.awsEndpoint} />
          </FontScaling>
        </GridThemeProvider>
      </ThemeProvider>
    </div>
  )
}

export default withAlert(Home)

export const homeQuery = graphql`
  query {
    wpPage(slug: { eq: "home" }) {
      id
      title
      acfCustomPageHeader {
        pageTitle
      }
      seo {
        ...SEOFragment
      }
      acfHomepage {
        sectionTitle
        tabHeading
        tabSubtitle
        tabLink
        showSection
        buttonText
        buttonLink {
          ... on WpPage {
            uri
          }
          ... on WpPost {
            uri
          }
        }
        impactTabs {
          tabTitle
          impactCards {
            cardMetric
            impactText
            impactIcon {
              localFile {
                childImageSharp {
                  fluid(
                    maxHeight: 55
                    maxWidth: 55
                    background: "transparent"
                    fit: CONTAIN
                    quality: 80
                    webpQuality: 70
                  ) {
                    base64
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                  }
                }
                extension
                publicURL
              }
            }
          }
        }
        bannerTabs {
          tabIndexText
          tabImage {
            localFile {
              childImageSharp {
                fluid(fit: COVER, quality: 90, webpQuality: 90) {
                  base64
                  aspectRatio
                  src
                  srcSet
                  srcWebp
                  srcSetWebp
                  sizes
                }
              }
              extension
              publicURL
            }
          }
          aboveTitleText
          belowTitleText
          buttonText
          isButtonLinkExternal
          buttonLinkExternal
          buttonLink {
            ... on WpPage {
              uri
            }
            ... on WpPost {
              uri
            }
          }
          hasPagepostLink
          titleText
        }
        contentTabs {
          hasGeneralLink
          linkTitle
          pageLink {
            ... on WpPage {
              uri
            }
            ... on WpPost {
              uri
            }
            ... on WpPressRelease {
              uri
            }
            ... on WpClinicalTrial {
              uri
            }
          }
          tabTitle
          contentCards {
            cardExcerpt
            cardTitle
            cardLink {
              target
              title
              url
            }
            cardImage {
              localFile {
                childImageSharp {
                  fluid(
                    fit: COVER
                    quality: 80
                    webpQuality: 70
                    maxHeight: 225
                    maxWidth: 400
                  ) {
                    base64
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                  }
                }
                extension
                publicURL
              }
            }
          }
        }
        adviceCards {
          cardLink {
            ... on WpPage {
              uri
            }
            ... on WpPost {
              uri
            }
          }
          cardSubtitle
          cardTitle
          cardIcon {
            localFile {
              childImageSharp {
                fluid(
                  maxHeight: 55
                  maxWidth: 55
                  quality: 80
                  webpQuality: 90
                  fit: CONTAIN
                  background: "transparent"
                ) {
                  aspectRatio
                  src
                  srcSet
                  srcWebp
                  srcSetWebp
                  sizes
                }
              }
              extension
              publicURL
            }
          }
        }
      }
    }
  }
`
